export default {
  storage: {
    id: 'product_picker_storage_a_label',
    defaultMessage: 'Storage',
  },
}
